// French for the gate vocabulary: the 27 automatic condition labels, the manual defaults and
// the route labels. Imported by EngagementPage (condRoutes.ts itself stays free of React and
// the API layer — the exhaustiveness test imports it directly).
import { registerFr } from '../../i18n/index.js';

registerFr({
  // ── automatic conditions (mirror src/server/utils/gates.ts) ──
  'Client record exists': 'Le dossier client existe',
  'Contact on file and named for this engagement': 'Contact enregistré et désigné pour ce mandat',
  'Qualification note recorded for this engagement': 'Note de qualification consignée pour ce mandat',
  'At least one document ingested and ready': 'Au moins un document ingéré et prêt',
  'Zero pending proposals': 'Aucune proposition en attente',
  'Zero unresolved conflicts': 'Aucun conflit non résolu',
  'Every requirement confirmed': 'Chaque exigence confirmée',
  'Every MUST requirement maps to a deliverable': 'Chaque exigence Doit est associée à un livrable',
  'No deliverable without a requirement': 'Aucun livrable sans exigence',
  'Estimate present': 'Estimation présente',
  'A SOW version is signed': 'Une version du SOW est signée',
  'Signature record captured on the signed version': 'Preuve de signature enregistrée sur la version signée',
  'Baseline created': 'Baseline créée',
  'Kickoff date logged': 'Date de kickoff enregistrée',
  'Plan has milestones': 'Le plan comporte des jalons',
  'Client access provisioned': 'Accès client mis en place',
  'All deliverables delivered': 'Tous les livrables sont livrés',
  'Every deliverable sits on an acceptance record': 'Chaque livrable repose sur un procès-verbal d’acceptation',
  'At least one acceptance record issued': 'Au moins un procès-verbal d’acceptation émis',
  'No open blocking or major defects': 'Aucun défaut bloquant ou majeur ouvert',
  'Acceptance record signed or deemed': 'Procès-verbal d’acceptation signé ou tacitement accepté',
  'Signature record captured on an accepted record': 'Preuve de signature enregistrée sur un procès-verbal accepté',
  'All defects closed': 'Tous les défauts sont clos',
  'No open questions outstanding': 'Aucune question ouverte en attente',
  'No undecided change requests': 'Aucune demande de modification non tranchée',
  'No unsigned acceptance records': 'Aucun procès-verbal d’acceptation non signé',
  'No open operator tasks': 'Aucune tâche d’opérateur ouverte',

  // ── manual defaults (mirror DEFAULT_MANUAL_ITEMS) ──
  'Sponsor identified and reachable': 'Sponsor identifié et joignable',
  'Commercial model agreed in principle': 'Modèle commercial convenu en principe',
  'Capacity available for the window': 'Capacité disponible pour la période',
  'Discovery sessions complete': 'Séances Discovery terminées',
  'Register walkthrough held with the client': 'Parcours du registre effectué avec le client',
  'Estimate sanity-checked against capacity': 'Estimation vérifiée face à la capacité',
  'Delivery approach agreed internally': 'Approche de réalisation convenue en interne',
  'Counter-signed copy filed': 'Copie contresignée classée',
  'Payment terms and PO confirmed': 'Conditions de paiement et bon de commande confirmés',
  'Kickoff held with the client team': 'Kickoff tenu avec l’équipe client',
  'Environments and access provisioned': 'Environnements et accès mis en place',
  'Reporting cadence agreed': 'Rythme de reporting convenu',
  'Milestone demo delivered': 'Démo de jalon tenue',
  'Milestone invoice raised': 'Facture de jalon émise',
  'UAT results reviewed with the sponsor': 'Résultats UAT examinés avec le sponsor',
  'Residual minor defects agreed in writing': 'Défauts mineurs résiduels convenus par écrit',
  'Runbook delivered': 'Manuel d’exploitation livré',
  'Training / handover session logged': 'Séance de formation / transfert consignée',
  'Hypercare window agreed': 'Période d’hypercare convenue',
  'Closure note written': 'Note de clôture rédigée',
  'Lessons learned captured': 'Lessons Learned consignées',
  'Final invoice raised': 'Facture finale émise',

  // ── route labels (COND_ROUTE[*].label) ──
  'Client record': 'Dossier client',
  'Name the sponsor on the engagement record': 'Nommer le sponsor dans le dossier du mandat',
  'Write the note on a G0 condition below': 'Écrire la note sur une condition G0 ci-dessous',
  'Documents · not ready': 'Documents · pas prêt',
  'Proposals · pending': 'Propositions · en attente',
  'Proposals · pending conflicts': 'Propositions · conflits en attente',
  'Register · status=draft': 'Registre · status=draft',
  'Register · unfunded MUST': 'Registre · exigences Doit non financées',
  'Register · deliverables': 'Registre · livrables',
  'Contracting · plan': 'Contractualisation · plan',
  'Contracting · SOW': 'Contractualisation · SOW',
  'Contracting · baselines': 'Contractualisation · baselines',
  'Set the kickoff date on the engagement record': 'Définir la date de kickoff dans le dossier du mandat',
  'Client Portal · grants': 'Portail client · autorisations',
  'Acceptance': 'Acceptation',
  'Acceptance · defects': 'Acceptation · défauts',
  'Register · open questions': 'Registre · questions ouvertes',
  'Contracting · change requests': 'Contractualisation · demandes de modification',
  'Dashboard · open tasks': 'Dashboard · tâches ouvertes',
}, 'condRoutes');
